import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  IconButton,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import Header from '../../../components/Header';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../theme';

const PackageDetails = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');
  const token = localStorage.getItem('token');

  const [packageDetails, setPackageDetails] = useState({
    PackageName: '',
    PackageDescription: '',
    PackageImage: '',
    CountryID: '',
    ExcursionIDs: [],
    PackagePrice: '',
  });
  const [excursions, setExcursions] = useState([]);
  const [country, setCountry] = useState([]);
  const [image, setImage] = useState(null);

  const getPackageDetails = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/packages/${id}`, { headers: { token } });
    const data = await res.json();
    setPackageDetails(data.package);
    // setExcursions(data.excursions);
  };

  const getCountryNames = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/countrynames`, { headers: { token } });
    const data = await res.json();
    setCountry(data);
  };

  useEffect(() => {
    getPackageDetails();
    getCountryNames();
  }, []);

  const getExcursions = async (countryID) => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/countryExcursions/${countryID}`, { headers: { token } });
    const data = await res.json();
    setExcursions(data.excursions);
  };

  useEffect(() => {
    if (packageDetails.CountryID) {
      getExcursions(packageDetails.CountryID);
    }
  }, [packageDetails.CountryID]);

  const handleChange = (e) => {
    setPackageDetails({ ...packageDetails, [e.target.name]: e.target.value });
  };

  const handleCountryChange = (e) => {
    setPackageDetails((prevPackageDetails) => ({
      ...prevPackageDetails,
      [e.target.name]: e.target.value,
      ExcursionIDs: [],
    }));
  };

  const imageHandler = (e) => {
    setImage(e.target.files[0]);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (image) {
      const formData = new FormData();
      formData.append('file', image);
      try {
        const res = await fetch(`${process.env.REACT_APP_APILINK}/packages/uploadimage`, {
          headers: { token },
          method: 'POST',
          body: formData,
        });
        const imageData = await res.json();

        if (imageData.message) {
          setOpenToast(true);
          setToastmessage(imageData.message);
        }

        if (imageData.success) {
          packageDetails.PackageImage = imageData.image;
        }
      } catch (error) {
        console.log(error);
      }
    }

    try {
      const { sortOrder: _ignoredSortOrder, ...updatePayload } = packageDetails;
      const res = await fetch(`${process.env.REACT_APP_APILINK}/packages/${id}`, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
          token,
        },
        body: JSON.stringify(updatePayload),
      });

      const data = await res.json();

      if (data.message) {
        setOpenToast(true);
        setToastmessage(data.message);
        if (data.success) {
          setTimeout(() => {
            navigate('/package');
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenToast(false);
  };

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  const MuiOutlinedInputStyle = {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.grey[300],
        },
      },
    },
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title={packageDetails.PackageName} subtitle="Package Details" />

        <Box>
          <Link to={-1}>
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '10px 20px',
                '&:hover': {
                  backgroundColor: colors.blueAccent[800],
                },
              }}
            >
              Go Back
            </Button>
          </Link>
        </Box>
      </Box>

      <form onSubmit={handleFormSubmit}>
        <Box
          style={{
            display: 'grid',
            gap: '1rem',
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Package Name"
            value={packageDetails.PackageName}
            onChange={handleChange}
            name="PackageName"
            required
            InputLabelProps={{ shrink: packageDetails.PackageName ? true : false, style: { color: colors.grey[300] } }}
            sx={MuiOutlinedInputStyle}
          />

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Package Description"
            value={packageDetails.PackageDescription}
            onChange={handleChange}
            name="PackageDescription"
            required
            InputLabelProps={{
              shrink: packageDetails.PackageDescription ? true : false,
              style: { color: colors.grey[300] },
            }}
            sx={MuiOutlinedInputStyle}
          />

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Country"
            value={packageDetails.CountryID}
            onChange={handleCountryChange}
            name="CountryID"
            required
            InputLabelProps={{ shrink: packageDetails.CountryID ? true : false, style: { color: colors.grey[300] } }}
            sx={MuiOutlinedInputStyle}
            select
          >
            {country &&
              country.map((country) => (
                <MenuItem key={country.CountryID} value={country.CountryID}>
                  {country.CountryName}
                </MenuItem>
              ))}
          </TextField>

          <FormControl
            InputLabelProps={{ shrink: packageDetails.CountryID ? true : false, style: { color: colors.grey[300] } }}
            sx={MuiOutlinedInputStyle}
          >
            <InputLabel id="demo-multiple-checkbox-label">Excursions</InputLabel>
            <Select
              label="Excursions"
              labelId="demo-multiple-checkbox-label"
              variant="outlined"
              value={packageDetails.ExcursionIDs}
              onChange={handleChange}
              name="ExcursionIDs"
              multiple
              required
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => {
                    const excursion = excursions.find((exc) => exc.ExcursionID === value);
                    return <Chip key={value} label={excursion ? excursion.ExcursionName : value} />;
                  })}
                </Box>
              )}
            >
              {excursions &&
                excursions.map((excursion) => (
                  <MenuItem key={excursion.ExcursionID} value={excursion.ExcursionID}>
                    <ListItemIcon>
                      <Checkbox checked={packageDetails.ExcursionIDs.includes(excursion.ExcursionID)}></Checkbox>
                    </ListItemIcon>
                    <ListItemText primary={excursion.ExcursionName}></ListItemText>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            variant="outlined"
            type="number"
            label="Package Price"
            value={packageDetails.PackagePrice}
            onChange={handleChange}
            name="PackagePrice"
            required
            InputLabelProps={{ shrink: true, style: { color: colors.grey[300] } }}
            sx={MuiOutlinedInputStyle}
            inputProps={{ min: 0, step: '0.01' }}
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
              backgroundColor: colors.primary[400],
              width: 'fit-content',
              padding: '15px',
            }}
          >
            <Box sx={{ display: 'flex', gap: '15px' }}>
              <Typography variant="h5" mt="10px" color={colors.grey[100]}>
                Package Image :
              </Typography>
              <Button
                onClick={() => {
                  setPackageDetails({ ...packageDetails, PackageImageURL: '' });
                }}
                variant="contained"
                sx={{
                  backgroundColor: colors.primary[500],
                  color: colors.grey[100],
                  width: 'fit-content',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  padding: '8px 15px',
                  marginBottom: '5px',
                  '&:hover': {
                    backgroundColor: colors.primary[600],
                  },
                }}
              >
                Remove Image
              </Button>
            </Box>
            <label
              htmlFor="file-input"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                background: colors.primary[400],
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                borderRadius: '10px',
                width: '400px',
                aspectRatio: '16/9',
              }}
            >
              {packageDetails.PackageImageURL ? (
                <img
                  src={packageDetails.PackageImageURL}
                  alt={packageDetails.PackageName}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : image ? (
                <img
                  src={URL.createObjectURL(image)}
                  alt={packageDetails.PackageImage}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <>
                  <CloudUploadIcon fontSize="large" /> Upload Image
                </>
              )}
            </label>
            <input type="file" accept="image/*" onChange={imageHandler} name="image" id="file-input" hidden />
          </Box>

          <Button
            type="submit"
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              width: 'fit-content',
              fontSize: '14px',
              fontWeight: 'bold',
              padding: '10px 30px',
              '&:hover': {
                backgroundColor: colors.blueAccent[800],
              },
            }}
          >
            Update
          </Button>
        </Box>
      </form>

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default PackageDetails;
